<!--销售中心选择门店信息-->
<template>
  <div>
    <!--头部中心-->
    <div class="choose-hotel">
       <img src="/images/public/guide_logo.png" height="50px" @click="$router.push('/')">
       <div>
        <el-button @click="saveBasicInfo(1)" type="primary" class="create-hotel-add mr-2">申请新企业</el-button>
        <el-button @click="logout">退出登录</el-button>
       </div>
    </div>
    <div class="chooseHotel">
      <div class="chooseHotel-tabs">
        <div :class="{'active':type==1}" @click="type=1">门店列表</div>
        <div :class="{'active':type==2}" @click="type=2">申请列表</div>
      </div>
      <div class="chooseHotel-content" v-loading="loading">
          <!--tab切换-->
          <div class="hotel-table" v-if="type==2">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="酒店申请" name="2"></el-tab-pane>
                <el-tab-pane label="解除酒店申请" name="4"></el-tab-pane>
                <el-tab-pane label="已解除" name="5"></el-tab-pane>
                <el-tab-pane label="已拒绝" name="3"></el-tab-pane>
              </el-tabs>
          </div>
          <!--申请关联新酒店-->
          <div class="hotel-table-btn" v-if="type==2&&activeName==2">
            <el-button type="primary" class="create-hotel-add mr-2" @click="finance=true">申请加入新酒店</el-button>
          </div>
          <!--酒店列表-->
          <ul class="hotel-info" v-if="!loading">
            <li v-for="item in salesAssociationLists.lists" :key="item.id" >
              <img v-lazy="ImgPreUrl + item.top_pic"  :alt="item.title" class="hotel-bg"  @click="chooseHotel(item)" v-if="type==1">
              <div class="hotel-name" :class="{'mt-3':type!=1}">
                {{item.title}}
                <img v-lazy="'/images/xj/icon_'+item.star+'.png'" :key="item.star" height="18px" v-if="type==1&&item.star>0"/>  
              </div>
              <div class="hotel-address" v-if="type==1">
                <img class="mr-2 pt-small"  height="18" :src="item.exp_icon ? '/images/grade/'+ item.exp_icon : ''" :title="item.exp_level+'级'"/>
                <span>活跃值:{{ item.exp }}</span>
              </div>
              <div class="hotel-menu" v-if="type==1">
                <div class="position_name" ><template v-if="item.position_name">职位：{{ item.position_name}}</template></div>
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    <el-button>操作</el-button>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{id:item.id,type:3}">发起确认单</el-dropdown-item>
                    <el-dropdown-item :command="{id:item.id,type:4}">更改职位</el-dropdown-item>
                    <el-dropdown-item :command="{id:item.id,type:1}">查看酒店</el-dropdown-item>
                    <el-dropdown-item :command="{id:item.id,type:2}">解除关联</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="hotel-menu lis" v-if="type!=1">
                <div>{{ item.add_time | formatTimestamp(1) }}</div>
                <div class="rimary" :class="$GFUN.correlationColor(item.status)">{{item.status  | formatVar('AssociatedState')}}</div>
              </div>
            </li>
          </ul>
          <p class="mt-6" v-if="salesAssociationLists.total<=0">当前没有数据</p>
      </div>
    </div>
    <!--申请关联新酒店-->
    <el-dialog title="加入酒店"  :visible.sync="finance" width="700px" class="paymentist" :close-on-click-modal="false" top="16%">
          <div class="search-wrap">
            <el-autocomplete
              class="inline-input"
              v-model="BasicInfo.title"
              :fetch-suggestions="querySearchAsync"
              placeholder="搜索酒店品牌或名称..."
              :trigger-on-focus="false"
              @select="handleSelect"
              prefix-icon="el-icon-search"
            >
            <template slot-scope="{ item }">
              <!-- v-html 必须用，渲染包裹的span标签 -->
              <span v-html="$verify.highlightKeyword(item.title, BasicInfo.title)"></span>
            </template>
            </el-autocomplete>
            <el-button type="primary" class="bottom" icon="el-icon-search" @click="onTextareaBlur()">立即搜索</el-button>
          </div>
          <!-- <div class="title-search">
            <div class="title-search-input">
              <left-text-border class="mb-3"
                leftText="酒店名称"
                placeholder="请输入您要加入的酒店名称"
                required
                inputId="inputTitle"
                v-model="BasicInfo.title"/>
            </div>
            <el-button type="primary" @click="onTextareaBlur" style="width:80px;height:32px; line-height: 10px;">搜索</el-button>
          </div> -->
            <!--搜索企业的列表-->
            <div v-if="isShow&&list.length == 0">
                未找到相关酒店，请重新输入
            </div>
            <ul class="list" v-if="list.length > 0">
              <li class="list-header">
                <div>酒店名称</div>
                <div>操作</div>
              </li>
              <li v-for="item in list" :key="item.id">
                <div>{{item.title}}</div>
                <div class="rimary cursor-pointer" @click="applyAssociation(item)">申请加入</div>
              </li>
            </ul>
          <el-pagination layout="prev, pager, next" background class="mt-3"
            :page-size="4"
            v-if="list.length > 0"
            :total=Number(total) :current-page="Number(BasicInfo.page)"
            @current-change="v => {this.BasicInfo.page=v;this.getHotelList()}" />
          <el-button @click="finance=false" class="mt-4 w-25 btn-login">返回</el-button>
    </el-dialog>
    <!--更改销售职位-->
    <el-dialog :title="'销售职位'" :visible.sync="changePosition" width="500px" center id="loadConfirm">
      <ChangePosition :changeStoreid="changeStoreid" :changeUseItem="changeUseItem" @changeSuccess="changeSuccess"></ChangePosition>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions,mapState,mapGetters} from 'vuex'
import { debounce } from "lodash";
import ChangePosition from '@/views/Admin/StoreManage/Components/ChangePosition'
export default {
  name: 'ChooseHotel',
  components: {ChangePosition},
  props: {},
  data() {
    return {
      total:'',
      list:[],
      activeName:'2',
      finance:false,        //关联酒店开关
      BasicInfo:{
        title:'',
        page:1,
        type:3,
        num:4,
      },
      type:1,              //当前分类
      isShow:false,        //是否是已搜索的状态
      loading:false,
      changePosition:false, //更改职位开关
      changeStoreid:'',
      changeUseItem:{}
    };
  },
  computed: {
    ...mapState(['salesAssociationLists','newMessageInform']),
    ...mapGetters(['storeInfo']),
  },
  watch: {
      type(newVal){
        this.loading = true;
        this.loadList();
      },
  },
  created() {
    this.loading = true;
    this.loadList()
  },
  mounted() {},
  methods: {
    ...mapMutations(['UPDATECURRENTSTORE','UPDATELOGININFO','UPDATECONFIRMINFO']),
    ...mapActions(['POST_UnionRecordList','logout','POST_checkStoreTitle','POST_UnionApply','POST_UnionRemoveApply','POST_UnionRecordSaleList','POST_SearchDocHotel','updateInfo','getUserIndexData']),
    //切换状态刷新列表
    handleClick(tab) {
      this.activeName = tab.name;
      this.loading = true;
      this.loadList();
    },
    //获取销售关联酒店状态列表
    loadList: debounce(function(){
      if(this.type==1){
        this.POST_UnionRecordSaleList({data:{},successFun:(res)=>{
          this.loading = false
        }})
      }else{
        let data = {
          status:this.activeName,
        }
        this.POST_UnionRecordList({data,successFun:()=>{this.loading = false}})
      }
    },500),
    //选择酒店
    chooseHotel(item){
        //更新本地用户酒店
        let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
        userMessage.storeId = item.id ||item;
        this.UPDATELOGININFO(userMessage);
        //获取用户索引数据
        this.getUserIndexData();
      // commit('UPDATEUSERHEAD', userStore);
    },
    /*失去焦点-搜索酒店*/
    async onTextareaBlur(e){
        this.BasicInfo.page=1;
        this.isShow=true;
        if(this.BasicInfo.title.trim()){
          this.getHotelList();
        }   
    },
    /*获取 已有酒店列表列表*/
    async getHotelList () {
      let result = await this.POST_checkStoreTitle(this.BasicInfo);
      this.list = result.list;
      this.total = result.count;
    },
    /*申请关联酒店*/
    async applyAssociation (item) {
      this.POST_UnionApply({
        data: {
          store_id:item.id,
          store_type:this.storeInfo.type,
        },
        successFun: () => {
          this.loadList();
          this.$message.success('申请成功，请耐心等待通过');
        },
      });
    },
    /*申请解除关联酒店*/
    async UnionRemoveApply (id) {
      this.POST_UnionRemoveApply({
        data: {
          store_id:id,
          store_type:this.storeInfo.type,
        },
        successFun: () => {
          this.loadList();
          this.$message.success('申请成功，请耐心等待通过');
        },
      });
    },
    /*点击操作按钮*/
    handleCommand(command){
      switch (command.type) {
        //解除关联操作
        case 1:
          let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + command.id);
          window.open(changeRoute.href, '_blank');

        break;
        case 2:
          this.UnionRemoveApply(command.id);
        break;
        //发确认单
        case 3:
          this.chooseHotel(command.id);
          this.UPDATECONFIRMINFO(command.id);
          let query = {orderConfirm:true,modify:true,orderConfirmSend:true}
          this.$router.push({name:'OrderPost',query})
        break;
        //更改职位
        case 4:
          console.log(this.storeInfo);
          this.changePosition = true;
          this.changeStoreid = command.id;
        break;

      }
    },
    /*更改职位成功*/
    changeSuccess(){
      this.changePosition=false;
      this.$message.success('更改职位成功');
      this.loadList();
    },
    /*点击创建门店*/
    saveBasicInfo(id=1) {
      //判断如果有创建门店信息,判断是否在认证如果认证则跳转认证页面,
      // if(this.userLoginMessage.submit_store_id>0){}
      //更新下用户信息在跳转防止多开数据未同步
      let routeUrl = this.$router.resolve({name:'StoreApplication',query:{type:3}});
      // this.updateInfo();
      // let name = id==1?'resBasicInfo':'regVerify';
      //   let routeUrl = this.$router.resolve({name:name,query:{step:1,sales:3}});
        window.open(routeUrl.href, '_blank');
      // this.$router.push({ name: name,query:{step:1,sales:3} });
    },
    //搜索框的建议列表
    async querySearchAsync(queryString, cb) {
      //内容不等于空字符串
      if (queryString.trim() === '') {
        cb([]);
        return;
      };
      let res= await this.POST_SearchDocHotel({data:{title: queryString}});
      this.timeout = setTimeout(() => {
        cb(res.list);
      }, 2000 * Math.random());
    },
    //点击搜索框的建议项-跳转详情
    handleSelect(item) {
      this.BasicInfo.title=item.title;
    },
  }
};
</script>
<style>
body{
  background-color: #f3f4f8;
}
</style>
<style lang="scss" scoped>
  .title-search{
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .title-search-input{
    width: 85%;
  }
  .chooseHotel{
    width: 94%;
    margin: 0 auto;
    display: flex;
    margin-top: 40px;
    overflow: hidden;
  }
  .chooseHotel-tabs{
    width: 180px;
    background-color: #eee;
    min-height:800px;
  }
  .chooseHotel-tabs div{
    height: 54px;
    line-height: 54px;
    cursor: pointer;
  }
  .chooseHotel-content{
    width: 100%;
    background-color: #fff;
  }
  .active{
    background-color: #fff;
    position: relative;
    border-radius: 4px 0 0 4px;
    overflow: hidden;
  }
  .active::after{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 6px;
    height: 100%;
    background-color: var(--smtc-color-primary);
  }

  .choose-hotel{
    width: 94%;
    padding: 15px 3%;
    height: 50px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
  }
  .create-hotel-add{
    margin-left: auto;
  }
  .hotel-table{
    width: 94%;
    margin: 0 auto;
    margin-top: 20px;
  }
  .hotel-info{
    width: 94%;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
  .hotel-info li{
    float: left;
    width: 19%;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 7px #eee;
    overflow: hidden;
    cursor: pointer;
    transition: all .3s cubic-bezier(0.4, 0, 0.2, 1);
    margin-right: 1.2%;
    margin-bottom: 30px;
    .hotel-bg{
      width: 100%;
      height: 200px;
      border-bottom: 1px #eee solid;
    }
  }
  .hotel-info li:nth-child(5n){
    margin-right: 0;
  }
  .hotel-info li:hover {
      border-color: #1890ff!important;
      box-shadow: 0 6px 16px -8px #00000014,0 9px 28px #0000000d,0 12px 48px 16px #00000008;
      transform: translateY(-2px)
  }
  .hotel-name{
    width: 90%;
    margin: 0 auto;
    padding: 6px 2%;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    vertical-align: middle; /* 垂直居中对齐文字 */
  }
  .hotel-name img{
    margin-top: 4px;
    margin-left: 4px;
  }
  .hotel-address{
    width: 90%;
    margin: 0 auto;
    padding: 6px 2%;
    font-size: 14px;
    text-align: left;
    display: flex;
  }
  .hotel-menu{
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 16px;
    border-top:1px #eee solid;
    padding-top: 16px;
    margin-top: 6px;
  }
  .hotel-table-btn{
    text-align: left;
    width: 94%;
    margin: 0 auto;
    margin-top: 20px;
  }
  .list{
    width: 100%;
    margin: 0 auto;
    border: 1px #dcdfe6 solid;
    border-bottom: none;
    border-radius:3px;
  }
  .list li{
    display: flex;
    justify-content: space-between;
    width: 100%;
    
  }

  .list li div{
    width: 71%;
    padding: 1.2% 2%;
    text-align: left;
    border-bottom: 1px #dcdfe6 solid;
  }
  .list li div:nth-child(2){
    width: 25%;
    text-align: center;
    border-left: 1px #dcdfe6 solid;

  }
  .list  .list-header div{
    text-align: center;
  }
  .rimary{
    color: var(--smtc-color-primary); 
  }
  .text-green{
    margin-left: 4px;
    margin-right: 4px;
    cursor: pointer;
  }
  .prompt{
    color: #999;
    margin-top: 10px;
    display: block;
    font-size: 13px;
  }
  .lis{
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    color: #999;
    border-top: 1px #eee solid;
    padding-top: 16px;
  }
    .search-wrap{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .inline-input{
    width: 80%;
  }
  .position_name{
    color: #666;
    line-height: 40px;
  }
</style>
